module.exports = __webpack_public_path__ + "img/ideation-04-keyfeature-ico-05-grey.b0646d58.svg";